import PropTypes from 'prop-types'
import React from 'react'
import UbigeoCitizenField from '../question_fields/UbigeoCitizenField'

const Citizen = props => {
  const { index, name, question, disabled = false, margin } = props
  return <UbigeoCitizenField index={index} {...question} name={name} disabled={disabled} margin={margin} />
}

const UbigeoQuestion = {
  Citizen,
  name: 'UbigeoQuestion'
}

export default UbigeoQuestion

Citizen.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  question: PropTypes.object
}
